function Header() {
  return (
    <header className="bg-offvine-purple py-4">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-center">
          <img
            src="/img/grapes.png"
            alt="OffVine Logo"
            className="w-10 h-10 mr-3"
          />
          <h1 className="text-2xl font-light text-white">
            offvine.wine
          </h1>
        </div>
      </div>
    </header>
  )
}

export default Header
